<template>
  <div class="precision-drive-scene">
    <!-- 顶部宣传区域 -->
    <div class="top-banner">
      <div class="top-banner-text">
        <div class="banner-content">
          <h2 class="title">{{ bannerData.title }}</h2>
          <h1 class="main-title">{{ bannerData.mainTitle }}</h1>
          <div class="icon-list">
            <div class="icon-item">
              <span>{{ bannerData.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-width">
      <div class="heading-text">
        <div style="padding: 10px 0;font-weight: bold;font-size: 24px">{{ $t('serviceRepair.repairRegistration') }}</div>
      </div>
      <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px"
               label-position="top">
        <div v-for="(item,index) in registerList" :key="index">
        <div>
          <div class="contact-title">{{item.groupName}}</div>
        </div>
          <el-row :gutter="15">
           <div v-for="(qitem,qindex) in item.registerStyleList" :key="qindex">
            <el-col :xs="24" :sm="8" :md="parseInt(qitem.modelSize)" >
              <el-form-item :label="qitem.title" :prop="qitem.fieldName" :required="qitem.isRequired === 'Y'">
<!--                <el-input :type="qitem.modelType" v-model="formData[qitem.fieldName]" :required="qitem.isRequired" :placeholder="`请输入` +qitem.title " clearable :style="{width: '100%'}" />-->
                <template v-if="qitem.modelType === 'date'">
                  <el-date-picker
                      v-model="formData[qitem.fieldName]"
                      type="date"
                      format="yyyy/MM/dd"
                      value-format="yyyy/MM/dd"
                      :placeholder="`${$t('serviceRepair.messages.pleaseSelect')}${qitem.title}`"
                      clearable
                      style="width: 100%"
                  />
                </template>

                <template v-else>
                  <el-input
                      :type="qitem.modelType"
                      v-model="formData[qitem.fieldName]"
                      :placeholder="`${$t('serviceRepair.messages.pleaseEnter')}${qitem.title}`"
                      clearable
                      style="width: 100%"
                  />
                </template>
              </el-form-item>
            </el-col>
           </div>
          </el-row>
        </div>
        <div>
          <div class="contact-title">{{ $t('serviceRepair.supplementaryExplanation') }}</div>
          <div class="explanation">{{ $t('serviceRepair.supplementaryExplanationContent') }}</div>
        </div>
        <div style="padding-top: 40px; text-align: center;">
          <el-button type="primary" class="repair-btn" @click="handleServiceRepair('elForm')">{{ $t('serviceRepair.send') }}</el-button>
        </div>
      </el-form>

      <div class="heading-text">
        <div style="padding: 10px 0;font-weight: bold;font-size: 24px">{{ $t('serviceRepair.localContactRepair') }}</div>
      </div>

      <div class="info-container">
        <el-row :gutter="15">
          <!-- 使用响应式栅格：大屏4列，中屏2列，小屏1列 -->
          <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              v-for="(contact,index) in contactList"
              :key="index"
          >
            <div class="info-card">
              <div class="contact-address">{{ contact.address }}</div>
              <div class="contact-info"><i class="el-icon-phone" style="width: 18px"/>{{ $t('serviceRepair.phone') }}{{ contact.phone }}</div>
              <div class="contact-info"><i class="el-icon-message" style="width: 18px"/>{{ $t('serviceRepair.email') }}{{ contact.email }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
<!--      <div v-if="bannerData.slogans" class="slogans-container">-->
<!--        <div class="slogans-text">{{ bannerData.slogans }}</div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import {getContactInformation, getRegisterGroupList, getRepairTitle} from "@/api/sysytem/homePage";

export default {
  name: 'serviceRepair',
  data() {
    return {
      contactList: [],
      registerList:[],
      formData: {
      },
      rules: {},
      getSelectOptions:[],
      bannerData: {
        title: '',
        mainTitle: '',
        content: '',
        slogans: '',
      }
    }
  },
  mounted() {
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      // 获取标题文本数据
      getRepairTitle({}).then(res => {
        if (res && res.data) {
          this.bannerData = {
            title: res.data.title || '',
            mainTitle: res.data.mainTitle || '',
            content: res.data.content || '',
            slogans: res.data.slogans || '',
          }
        }
      })
      getContactInformation({},{}).then(res => {
        this.contactList =res
      })
      getRegisterGroupList({}).then(res => {
        this.registerList =res
        this.registerList.forEach(item => {
          item.registerStyleList.forEach(qitem => {
            if (qitem.isRequired === 'Y') {
              // 为必填字段添加验证规则
              this.$set(this.rules, qitem.fieldName, [
                {
                  required: true,
                  message: `${this.$t('serviceRepair.messages.pleaseEnter')}${qitem.title}`,
                  trigger: 'blur'
                }
              ]);
            }
          });
        });
      })
    },
    handleServiceRepair(formName) {
      let data =[]
      this.registerList.forEach(item => {
        let d = {
          groupName : item.groupName,
          styleList: []
        }
        item.registerStyleList.forEach(qitem => {
          let q = {
            name : qitem.title,
            fieldName : qitem.fieldName,
            value : this.formData[qitem.fieldName],
          }
          d.styleList.push(q)
        })
        data.push(d)
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message.success(this.$t('serviceRepair.messages.sendSuccess'));
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
.precision-drive-scene {
  background-color: #000;
  overflow: hidden;
}
::v-deep .el-form-item__content .el-input__inner {
  line-height: normal; /* 或 line-height: 0; 根据实际需求选择 */
}

/* 顶部宣传区域样式 */
.top-banner {
  color: #fff;
  width: 100%;
  height: 360px;
  margin: auto;
  background-image: url("@/assets/img/shebeibeijing1.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
}

.top-banner-text {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px; /* 增加左右内边距，避免小屏内容贴边 */
  position: relative;
  width: 100%;
  max-width: 1165px; /* 最大宽度保持原尺寸 */
}
.banner-content {
  max-width: 500px;
}
.title {
  font-size: 18px;
  margin: 0 0 8px;
  opacity: 0.8;
}
.main-title {
  font-size: 36px;
  margin: 0 0 16px;
  font-weight: bold;
}
.icon-list {
  display: flex;
  gap: 20px;
}
.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon-item span {
  font-size: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  opacity: 0.8;
}

.info-container {
  width: 100%;
  max-width: 1165px; /* 最大宽度保持原尺寸 */
  margin: auto;
  margin-bottom: 50px;
  /* padding: 0 20px; 增加内边距 */
  box-sizing: border-box; /* 确保内边距不影响宽度计算 */
}
.info-card {
  background-color: rgba(255,255,255,0);
  /* padding: 10px 15px; */
  color: #fff;
  margin-bottom: 15px; /* 小屏下增加卡片间距 */
}

.el-form {
    padding: 0 40px;
}

::v-deep .el-form-item__label {
  color: #FFFFFF;
  font-size: 16px;
}

::v-deep .el-input--medium .el-input__inner {
  color: #CCCCCC;
  font-size: 15px;
}

.heading-text {
  border-bottom: solid 1px #fff;
  margin-bottom: 8px;
  color: #fff;
  position: relative;
  /* padding: 0 20px; */
}

.heading-text div {
  display: inline-block;
  position: relative;
}

.heading-text div::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background-color: #1A7AFF;
  z-index: 2;
}

.main-width {
  width: 100%;
  max-width: 1165px; /* 最大宽度保持原尺寸 */
  margin: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.contact-address {
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: bold;
  font-size: 20px;
  line-height: 36px;
}
.contact-info {
  font-family: Noto Sans SC, Noto Sans SC;
  font-size: 14px;
  font-weight: 100;
}
.contact-title {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}
.explanation {
  color: #fff;
  font-size: 14px;
  height: auto; /* 改为自动高度，避免文字截断 */
  line-height: 1.5; /* 增加行高，提升可读性 */
  padding: 10px 0;
}
.repair-btn {
  width: 220px;
  height: 36px;
  background: #006BFF;
  border-radius: 3px;
}
.slogans-container {
  margin-top: 30px;
  padding: 0 40px;
}
.slogans-text {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.8;
}

/* 媒体查询：小屏设备适配 */
@media (max-width: 768px) {
  .top-banner {
    height: 240px; /* 适当降低高度 */
  }
  .main-title {
    font-size: 28px; /* 减小标题字体 */
  }
  .title {
    font-size: 16px;
  }
  .contact-address {
    font-size: 18px;
  }
  .repair-btn {
    width: 100%; /* 按钮全屏宽 */
    max-width: 220px; /* 最大宽度限制 */
  }
  .explanation {
    font-size: 14px;
  }
  .icon-item span {
    -webkit-line-clamp: 3; /* 小屏设备显示3行 */
  }
}

/* 中等屏幕设备适配 */
@media (max-width: 576px) {
  .icon-item span {
    -webkit-line-clamp: 2; /* 中等屏幕显示2行 */
  }
}

/* 小屏幕设备适配 */
@media (max-width: 480px) {
  .icon-item span {
    -webkit-line-clamp: 1; /* 小屏幕显示1行 */
  }
}

/* 超小屏幕设备适配 */
@media (max-width: 360px) {
  .icon-item {
    display: none; /* 超小屏幕时隐藏 */
  }
}

/* 超小屏设备适配 */
@media (max-width: 480px) {
  .top-banner {
    height: 200px;
  }
  .main-title {
    font-size: 24px;
  }
  .heading-text div {
    font-size: 20px; /* 减小标题大小 */
  }
  .contact-title {
    font-size: 18px;
  }
}
</style>
